<template>
  <div id="ges-detail" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="row p-2 mx-auto">
        <header-v2 :title="'Sistema de vigilancia epidemiológico'" />
        <div class="row w-100 mt-5">
          <div class="col-md-12">
            <div style="display: flex; left: 15px; margin-bottom: 10px">
              <label class="mr-2 breadcrumb-link"
                ><button
                  class="mt-0 p-0 pb-1 d-flex align-items-center breadcrumb-link back"
                  style="
                    border: none;
                    background-color: transparent;
                    font-size: 16px;
                  "
                  @click.prevent="backGes"
                >
                  Todos los Ges
                </button></label
              >
            </div>

            <div>
              <b-overlay :show="loading" rounded="sm">
                <template #overlay>
                  <OverlayButton clase="overlay-md"> </OverlayButton>
                </template>
                <info-ges
                  :getProcessingEmployees="getProcessingEmployees"
                  @updateGES="updateGES"
                />
              </b-overlay>

              <b-overlay :show="loading" rounded="sm">
                <template #overlay>
                  <OverlayButton clase="overlay-md"> </OverlayButton>
                </template>
                <b-tabs
                  content-class="mt-5"
                  v-model="tabIndex"
                  @input="changeTab"
                >
                  <b-tab title="Información de personas">
                    <table-info-person
                      :ges="ges"
                      :numberIpt="numberIpt"
                      @savePersonIpt="savePersonIpt"
                      :isIpt="isIpt"
                      v-if="tabIndex === 0 ? true : false"
                    />
                  </b-tab>
                  <b-tab title="Historial de modificaciones">
                    <div v-if="isVisibledHistory">
                      <table-history />
                    </div>
                  </b-tab>
                  <b-tab
                    title="Personas seleccionadas para IPT"
                    :disabled="isVisibled"
                  >
                    <table-person-selected-ipt
                      v-if="tabIndex === 2 ? true : false"
                    />
                  </b-tab>
                </b-tabs>
              </b-overlay>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 3 MODAL PROCESO EXITOSO  -->
    <modal-success :messageModal="messageModal" :getUsersNotAdded="{}" />
  </div>
</template>

<script>
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import { mapGetters, mapActions, mapState } from "vuex";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import TablePersonSelectedIpt from "./components/TablePersonSelectedIpt.vue";
import InfoGes from "./components/detailGes/InfoGes.vue";
import TableInfoPerson from "./components/detailGes/TableInfoPerson.vue";
import TableHistory from "./components/detailGes/TableHistory.vue";
import ModalSuccess from "./modals/ModalSuccess";

export default {
  components: {
    HeaderV2: () => import("@/components/common/header/HeaderV2.vue"),
    MainBarMenuV2,
    HeadingUser,
    OverlayButton,
    TablePersonSelectedIpt,
    InfoGes,
    TableInfoPerson,
    TableHistory,
    ModalSuccess,
  },
  data() {
    return {
      id: this.$route.params.id,
      type: this.$route.params.type,
      category: this.$route.params.category,
      ipt: this.$route.params.ipt,
      tabIndex: 0,
      messageModal:
        "Recuerda por favor diligenciar el formulario de IPT por cada uno de los trabajadores",
      isIpt: false,
      numberIpt: 0,
      isVisibled: false,
    };
  },
  computed: {
    ...mapGetters("htGes", ["getProcessingEmployees"]),
    ...mapState("modSVE", ["ges", "loading"]),
    isVisibledHistory() {
      const me = this;
      return me.tabIndex === 1 ? true : false;
    },
  },
  watch: {
    "$route.params.ipt": {
      immediate: true,
      handler(newVal) {
        this.tabIndex = parseInt(newVal, 10) || 0;
      },
    },
  },
  methods: {
    ...mapActions("modSVE", ["actGetGES"]),
    ...mapActions("htGes", ["indexEmployee", "updateStateEmployee"]),
    async getGes(id) {
      const me = this;
      me.updateStateEmployee();
      me.numberIpt = 0;
      me.isIpt = true;
      me.actGetGES(id).then(async () => {
        me.isVisibled = me.ges?.ipts > 0 ? false : true;
        me.loadEmployee();
      });
    },
    async loadEmployee() {
      const me = this;
      try {
        await me.indexEmployee({ id: me.ges.id });
        me.isIpt = me.ges?.made_ipts === me.ges?.ipts ? true : false;
        me.numberIpt = me.ges?.ipts - me.ges?.made_ipts;
      } catch (error) {
        console.log(error);
      }
    },
    updateGES() {
      const me = this;
      me.getGes(me.id);
    },
    savePersonIpt() {
      const me = this;
      me.tabIndex = 2;
    },
    backGes() {
      const me = this;
      me.$router.push({
        name: "sve",
        params: {
          category: me.category,
          type: me.type,
        },
      });
    },
    changeTab() {
      const me = this;
      const tabIndex = me.tabIndex === 0 ? "0" : me.tabIndex === 1 ? "1" : "2";
      me.$router.push({
        name: "detailSve",
        params: {
          id: me.id,
          category: me.category,
          type: me.type,
          ipt: tabIndex,
        },
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
    const me = this;
    me.ipt = to.params.ipt;
    if (me.ipt === "0") me.getGes(me.id);
    next();
  },
  mounted() {
    const me = this;
    me.getGes(me.id);
  },
};
</script>

<style lang="scss">
.back {
  background-color: white;
  border: none;
}
</style>
